import React from "react";
import { Stack } from "@mui/system";
import { Helmet } from "react-helmet-async";

import TitleProject from "../Components/Title";
import Ouvidoria from "../../../components/Ouvidoria";

import './style.scss';
import Galery from "./galery";


export default function BarcarenaHse(){

  return(

  <>
  <Helmet title="Barcarena HSE - Séculos Engenharia e Serviços LTDA" />
  <TitleProject name="BARCARENA HSE" link1={"Projetos/ "} link2={"BARCARENA-HSE"} />
    <section id="context">
      <div className="container">

      <div>
        <Stack
          direction={{xs: 'column', sm: 'row'}}
          spacing={{xs: 1, sm: 2, md: 4}}
          className="context-desc"
        >
          <div className="context-box">
            <div className="context-desc-inside">
              <h2>Barcarena hse</h2>
              <p>
                Prestação de serviços em Gestão de SSMA - Saúde, Segurança e Meio Ambiente na Hydro em Barcarena – PA.
              </p>
            </div>
          </div>

          <div className="context-box context-info">
              <h2>Informações do Projeto</h2>
              <ul>
                <li><strong>Cliente: </strong> Hydro</li>
                <li><strong>Cidade: </strong> Barcarena - PA </li>
                <li><strong>Ano: </strong> 2020 </li>
                <li><strong>Segmento: </strong> Gestão de SSMA </li>
              </ul>
          </div>

        </Stack>
      </div>
      </div>
    </section>

    <Galery />
    <Ouvidoria/>
  </>
)
}